<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <faturaviewer ref="faturaviewer"></faturaviewer>
    <snackbarcomp v-bind:mesaj="text1" ref="showMessage" v-model="snackbar"></snackbarcomp>
   
    <v-app id="inspire" light>
      <v-card flat>
        <v-layout row wrap>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title class="baslikfont">{{'Satış Fatura Entegrasyonu'}}</v-toolbar-title>
            <v-spacer></v-spacer>



            <v-text-field flat="" @keyup.enter="faturaarama(searchliste)" solo-inverted="" hide-details
              v-model="searchliste" :label=" $t('Search')" @click:append="dialogac()" append-icon="live_help"></v-text-field>

            <v-tooltip bottom>
              <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="serbestfaturaEkle()" flat> <span
                  class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{ $t('Add-v2', { value: $t('Free-Invoice')}) }} </span>
                </span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>
              <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
              <span v-if="sayfayetki.Save">{{ $t('Add-v2', { value: $t('Free-Invoice')}) }}</span>
            </v-tooltip>


            <v-menu bottom left>
              <v-btn slot="activator" dark icon>
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <!-- <v-tooltip bottom>
                  <v-list-tile slot="activator" :disabled="!sayfayetki.Update" @click="faturaiptaldialog()">
                    <v-list-tile-title>{{ $t('Cancel-Invoice') }}</v-list-tile-title>
                  </v-list-tile>
                  <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                  <span v-if="sayfayetki.Update">  {{ $t('Cancel-Invoice') }}</span>
                </v-tooltip> -->

                <!-- <v-tooltip bottom>
                  <v-list-tile slot="activator" :disabled="!sayfayetki.Update" @click="faturaserinodialogac()">
                    <v-list-tile-title> {{ $t('Change-Invoice-Series-No')}}</v-list-tile-title>
                  </v-list-tile>
                  <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                  <span v-if="sayfayetki.Update">{{ $t('Change-Invoice-Series-No')}}</span>
                </v-tooltip> -->


                <v-tooltip bottom>
                  <v-list-tile slot="activator" :disabled="!sayfayetki.Update" @click="OnayaGonderTopluv2()">
                    <v-list-tile-title> {{ 'Tümünü Entegre Et' }} </v-list-tile-title>
                  </v-list-tile>
                  <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                  <span v-if="sayfayetki.Update"> {{ 'Tümünü Entegre Et' }} </span>
                </v-tooltip>


                <!-- <v-list-tile @click="getListHtml()">
                  <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>
                </v-list-tile>


                <v-list-tile @click="getListExcel()">
                  <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                </v-list-tile> -->
              
              </v-list>
            </v-menu>
          </v-toolbar>

          <v-container fluid="">
            <v-layout row wrap>
              <v-flex xs12 sm6 md4 style="padding-right:2px;">
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">trending_up</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm3 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-bold">
                                  {{ $t('Free') }}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-bold">
                                  : {{serbestAdet}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm3 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-bold">
                                  Coper
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-bold">
                                  : {{coperAdet}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm3 md4>
                              <v-list-tile-title>
                                <div class="font-weight-bold subheading  white--text  mb-1">{{ $t('Ticket') }}</div>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <div class="font-weight-bold subheading  white--text  mb-1">: {{biletAdet}} </div>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>

                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    {{$t('totalnumber')}} :{{ToplamAdetbilcopser}}
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>


              <v-flex xs12 sm6 md4 style="padding-right:2px;">
                <v-card color="#4CAF50" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">queue</v-icon>
                      </v-layout>
                    </v-flex>


                    <v-flex xs12 sm10 md10>
                      <v-card-title primary-title="">


                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm3 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-bold">
                                  {{$t('Hard-Copy-Invoice')}} </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-bold">
                                  : {{kagıtAdet}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>


                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm3 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-bold">
                                  {{ $t('E-Invoice') }}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-bold">
                                  : {{efaturaAdet}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm3 md6>
                              <v-list-tile-title>
                                <div class="font-weight-bold subheading  white--text  mb-1">E-Arşiv</div>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md6>
                              <v-list-tile-title>
                                <div class="font-weight-bold subheading  white--text  mb-1">: {{earsivAdet}} </div>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-card-title>
                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                   {{$t('totalnumber')}}: {{ToplamAdetkagefatears}}
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>

              <v-flex xs12 sm6 md4 style="padding-right:2px;">
                <v-card color="#FF6F00" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">poll</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>


                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm5 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-bold">
                                   {{ $t('Total-VAT') }} 
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm7 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-bold">
                                  : {{toplamKDV | moneyformat }}{{getparabirimi()}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm5 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-bold">

                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm7 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-bold">

                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex md4>
                              <v-list-tile-title>
                                <div class="font-weight-medium subheading  white--text title mb-1"></div>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex md8>
                              <v-list-tile-title>
                                <div class="font-weight-medium subheading  white--text title mb-1"></div>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>

                      </v-card-title>


                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                   {{$t('totalamount')}}: {{ToplamKDVMat| moneyformat }}{{getparabirimi()}}
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>

            </v-layout>
          </v-container>



          <v-container fluid="">
            <v-form ref="formtarih" v-model="valid" lazy-validation>
              <v-layout row wrap="">

                <v-flex xs12 sm4 md2>
                  <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"
                    :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'" v-bind:value="date"
                    v-model="date"></tarihcomp>
                </v-flex>

                <v-flex xs12 sm4 md2>
                  <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false" :rules="[v => !!v || $t('Please-select-a-date')]"
                    v-bind:defaultvalue="'ok'" v-bind:value="date2" v-model="date2"></tarihcomp>
                </v-flex>

                <v-flex>
                  <v-layout>
                    <div v-if="load1">
                      <v-btn color="info" @click="getList(1,kayitadet,siralamatipi,true)" fab small="" dark>
                        <v-icon>search</v-icon>
                      </v-btn>
                    </div>
                    <div v-if="!load1">
                      <v-layout align-center="" fill-height>
                        <v-progress-circular indeterminate color="info"></v-progress-circular>
                      </v-layout>
                    </div>
                    <v-badge color="white" :overlap="true">
                      <template v-slot:badge>
                        <v-icon v-if="filtrevarmi" large color="green">
                          check_circle_outline </v-icon>
                      </template>

                      <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                        @click="filtrele()" color="info" fab dark>
                        <v-icon>filter_list</v-icon>
                      </v-btn>
                      <v-tooltip bottom="" :activator="el" v-model="tooltip">
                        <span>{{$t('Add-Search-Filter')}}</span>
                      </v-tooltip>
                    </v-badge>
                  </v-layout>
                </v-flex>

                <v-flex v-show="kayitvarmi && this.filtretip=='1'" xs12 sm5 md5>
                  <v-layout justify-end="">
                    <v-btn @click="filtreiptal()" color="info">
                      <v-icon>cancel</v-icon> &nbsp; {{ $t('Cancel-Process') }}
                    </v-btn>


                    <v-btn @click="OnayaGonderTopluv2()" color="info">
                      <v-icon>playlist_add_check</v-icon> &nbsp; {{'Seçili Faturaları Entegre Et'}}
                    </v-btn>
                  </v-layout>
                </v-flex>
                <reportbrosablon v-show="false" ref="reportbrosablon" v-model="dizayn" dizayngrupadi="Fatura"
                  objectname="Controllers.ReportBro.Invoice.InvoicePrint"></reportbrosablon>
              </v-layout>
            </v-form>
          </v-container>

          <v-layout row="" wrap>
            <v-flex xs12 sm12 md12>
              <v-card>
                <v-flex v-show="kayitvarmi" xs12 sm12 md12>
                  <v-layout row wrap>
                    <v-flex ma-1 xs12 sm12 md8>
                      <v-layout align-center="" fill-height="">
                        <div class=" font-weight-large grey--text title ">
                          &nbsp; {{recordcount}} 
                          <span v-if="secilenkayitlar.length > 0" class=" font-weight-large red--text title ">
                            / {{secilenkayitlar.length}} {{ $t('Records-are-selected') }} </span>
                        </div>
                      </v-layout>
                    </v-flex>
                    <v-flex ma-1 v-show="kayitvarmi" xs12 sm12 md2>
                      <v-select hide-details="" :items="siralamatipiitems" color="grey darken-1" v-model="siralamatipi"
                        item-text="text" item-value="value" :label="$t('Sort-By')"></v-select>
                    </v-flex>
                    <v-flex ma-1 v-show="kayitvarmi" xs12 sm12 md1>
                      <v-select hide-details="" :items="kayitsayisi" color="grey darken-1" v-model="kayitadet"
                        item-text="text" item-value="value" :label="$t('Show')"></v-select>
                    </v-flex>
                  </v-layout>

                  <v-layout>
                    <v-list-tile>
                      <v-list-tile-content>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md12>
                            <v-layout v-if="kayitvarmi" justify-center="" align-center>
                               <v-checkbox v-model="tumunuseckaldir" :label="$t('Choose-All')"></v-checkbox> 
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-list-tile-content>
                    </v-list-tile>

                  </v-layout>

                </v-flex>





                <v-flex pa-2 v-for="item in sortedArray" v-bind:key="item.id" xs12 sm12 md12>
                  <v-hover>
                    <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" width="100%">
                      <v-list two-line="">
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md12>
                            <v-card flat class="black--text">
                              <v-card flat="">
                                <v-card-actions>
                                  <v-layout row wrap>
                                    <v-list-tile>
                                      <v-list-tile-content>
                                        <v-layout justify-center="" align-center>
                                          <v-checkbox hide-details="" v-model="secilenkayitlar" :value="item">
                                          </v-checkbox> 
                                        </v-layout>
                                      </v-list-tile-content>
                                    </v-list-tile>


                                     <v-flex  xs12 sm4 md3 xl2>
                                      <v-layout
                                        v-show="$vuetify.breakpoint.md || $vuetify.breakpoint.sm  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                                        align-center justify-start fill-height>
                                        <v-card flat="" >
                                          <v-list-tile>
                                            <v-list-tile-content>
                                              <v-layout row align-center justify-start>
                                                <v-chip small="" color="pink" v-if="item.GenelBilgileri.Tip=='COP'"
                                                  text-color="white">
                                                  <v-avatar>
                                                    <v-icon color="white">hotel</v-icon>
                                                  </v-avatar>
                                                  Coper
                                                </v-chip>
                                                <v-chip small="" color="pink" v-if="item.GenelBilgileri.Tip=='COK'"
                                                  text-color="white">
                                                  <v-avatar>
                                                    <v-icon color="white">hotel</v-icon>
                                                  </v-avatar>
                                                  Coper {{$t('Commission')}}
                                                </v-chip>
                                                <v-chip small="" color="pink" v-if="item.GenelBilgileri.Tip=='COI'"
                                                  text-color="white">
                                                  <v-avatar>
                                                    <v-icon color="white">hotel</v-icon>
                                                  </v-avatar>
                                                  Coper iade
                                                </v-chip>

                                                <v-chip small="" color="red" v-if="item.GenelBilgileri.Tip=='IADE'"
                                                  text-color="white">
                                                  <v-avatar>
                                                    <v-icon color="white">how_to_vote</v-icon>
                                                  </v-avatar>
                                                  İade Servis
                                                </v-chip>
                                                <v-chip small="" color="green" v-if="item.GenelBilgileri.Tip=='BLT'"
                                                  text-color="white">
                                                  <v-avatar>
                                                    <v-icon color="white">airplanemode_active</v-icon>
                                                  </v-avatar>
                                                  {{ $t('Ticket') }}
                                                </v-chip>
                                                <v-chip small="" color="info" v-if="item.GenelBilgileri.Tip=='SER'"
                                                  text-color="white">
                                                  <v-avatar>
                                                    <v-icon color="white">filter_none</v-icon>
                                                  </v-avatar>
                                                  {{ $t('Free') }}
                                                </v-chip>

                                              </v-layout>

                                              <v-list-tile-sub-title >
                                                <div class="font-weight-bold"> 
                                               {{$t('Invoice-Series-No')}}:{{item.GenelBilgileri.OnayFaturaNo}} 
                                                </div>
                                              </v-list-tile-sub-title>
                                              <v-list-tile-sub-title>
                                                <v-layout justify-start="" align-center>

                                                  <span v-if="item.GenelBilgileri.FaturaTip=='0'"> {{ $t('Paper') }} </span>
                                                  <span v-if="item.GenelBilgileri.FaturaTip=='1'">{{ $t('E-Invoice') }}</span>
                                                  <span v-if="item.GenelBilgileri.FaturaTip=='2'">{{$t('E-Archive')}}</span>
                                                </v-layout>
                                              </v-list-tile-sub-title>



                                            </v-list-tile-content>
                                          </v-list-tile>
                                        </v-card>
                                      </v-layout>

                                      <v-layout v-show="$vuetify.breakpoint.xs" align-center justify-center row
                                        fill-height>
                                        <v-card flat="">
                                          <v-list-tile>
                                            <v-list-tile-content>
                                              <v-layout row align-center justify-center>
                                                <v-chip small="" color="pink" v-if="item.GenelBilgileri.Tip=='COP'"
                                                  text-color="white">
                                                  <v-avatar>
                                                    <v-icon color="white">hotel</v-icon>
                                                  </v-avatar>
                                                  Coper
                                                </v-chip>
                                                <v-chip small="" color="pink" v-if="item.GenelBilgileri.Tip=='COK'"
                                                  text-color="white">
                                                  <v-avatar>
                                                    <v-icon color="white">hotel</v-icon>
                                                  </v-avatar>
                                                  Coper {{$t('Commission')}}
                                                </v-chip>
                                                <v-chip small="" color="pink" v-if="item.GenelBilgileri.Tip=='COI'"
                                                  text-color="white">
                                                  <v-avatar>
                                                    <v-icon color="white">hotel</v-icon>
                                                  </v-avatar>
                                                  Coper iade
                                                </v-chip>


                                                <v-chip small="" color="green" v-if="item.GenelBilgileri.Tip=='BLT'"
                                                  text-color="white">
                                                  <v-avatar>
                                                    <v-icon color="white">airplanemode_active</v-icon>
                                                  </v-avatar>
                                                  {{ $t('Ticket') }}
                                                </v-chip>
                                                <v-chip small="" color="info" v-if="item.GenelBilgileri.Tip=='SER'"
                                                  text-color="white">
                                                  <v-avatar>
                                                    <v-icon color="white">filter_none</v-icon>
                                                  </v-avatar>
                                                  {{ $t('Free') }}
                                                </v-chip>

                                              </v-layout>

                                              <v-list-tile-sub-title>
                                                <div class="font-weight-bold  "> {{ $t('Invoice-Series-No') }}
                                                  {{item.GenelBilgileri.OnayFaturaNo}}
                                                </div>
                                              </v-list-tile-sub-title>
                                              <v-list-tile-sub-title>
                                                <v-layout justify-center="" align-center>

                                                  <span v-if="item.GenelBilgileri.FaturaTip=='0'"> {{ $t('Paper') }} </span>
                                                  <span v-if="item.GenelBilgileri.FaturaTip=='1'"> {{ $t('E-Invoice') }}  </span>
                                                  <span v-if="item.GenelBilgileri.FaturaTip=='2'">{{ $t('E-Archive') }}</span>
                                                </v-layout>
                                              </v-list-tile-sub-title>



                                            </v-list-tile-content>
                                          </v-list-tile>
                                        </v-card>
                                      </v-layout>

                                    </v-flex>


                                    <v-flex xs12 sm4 md2>
                                      <v-layout justify-center="" column="" align-center="">
                                        <v-card flat="">
                                          <v-list-tile>
                                            <v-list-tile-content>
                                              <v-layout justify-center="" align-center="">
                                                <v-flex>

                                                  <v-list-tile-sub-title>
                                                    <v-layout justify-center="" align-center>
                                                      <div class="font-weight-bold red--text subheading ">
                                                        {{item.TarihBilgileri.FaturaTarihi}}
                                                      </div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>
                                                  <v-list-tile-sub-title>

                                                    <v-chip small="" color="red"
                                                      v-if="item.GenelBilgileri.EFaturaShowID.FaturaStatus!='Fatura Beklemede' &&  item.GenelBilgileri.EFaturaShowID.FaturaStatus!='Alıcı Onayladı' &&  item.GenelBilgileri.EFaturaShowID.FaturaStatus!='Fatura Gönderildi'"
                                                      text-color="white">
                                                      <v-avatar>
                                                        <v-icon color="white">radio_button_unchecked</v-icon>
                                                      </v-avatar>
                                                      {{$t(item.GenelBilgileri.EFaturaShowID.FaturaStatus)}}
                                                    </v-chip>

                                                    <v-chip small="" color="pink"
                                                      v-if="item.GenelBilgileri.EFaturaShowID.FaturaStatus=='Fatura Beklemede'"
                                                      text-color="white">
                                                      <v-avatar>
                                                        <v-icon color="white">access_alarm</v-icon>
                                                      </v-avatar>
                                                      
                                                      {{$t(item.GenelBilgileri.EFaturaShowID.FaturaStatus)}}
                                                    </v-chip>

                                                    <v-chip small="" color="green"
                                                      v-if="item.GenelBilgileri.EFaturaShowID.FaturaStatus=='Alıcı Onayladı'"
                                                      text-color="white">
                                                      <v-avatar>
                                                        <v-icon color="white">done_all</v-icon>
                                                      </v-avatar>
                                                      {{$t(item.GenelBilgileri.EFaturaShowID.FaturaStatus)}}
                                                    </v-chip>

                                                    <v-chip small="" color="info"
                                                      v-if="item.GenelBilgileri.EFaturaShowID.FaturaStatus=='Fatura Gönderildi'"
                                                      text-color="white">
                                                      <v-avatar>
                                                        <v-icon color="white">send</v-icon>
                                                      </v-avatar>
                                                      {{$t(item.GenelBilgileri.EFaturaShowID.FaturaStatus)}}
                                                    </v-chip>
                                                  </v-list-tile-sub-title>
                                                </v-flex>
                                              </v-layout>
                                            </v-list-tile-content>
                                          </v-list-tile>
                                        </v-card>
                                      </v-layout>
                                    </v-flex>



                                    <v-flex xs12 sm4 md3>
                                      <v-layout>
                                        <v-flex xs12 sm12 md12>
                                          <v-layout align-start="" justify-start fill-height>
                                            <v-card flat="">
                                              <v-list-tile>
                                                <v-list-tile-content style="'overflow=inherit';">
                                                  <v-list-tile-sub-title>
                                                    <div class="font-weight-bold caption ">
                                                      {{$t('Customer-Code')}}: {{item.GenelBilgileri.Cari.Kod}}
                                                    </div>
                                                  </v-list-tile-sub-title>
                                                  <v-list-tile-sub-title>
                                                    <div class="font-weight-bold caption text-truncate">
                                                     {{$t('Title')}}: 
                                                      <span v-if="item.GenelBilgileri.Cari.Unvan.length > 25">
                                                        {{
                                                         item.GenelBilgileri.Cari.Unvan.substring(0,25) 
                                                      }}<br/>{{item.GenelBilgileri.Cari.Unvan.substring(25)}}
                                                      </span>
                                                      <span v-else>
                                                        {{item.GenelBilgileri.Cari.Unvan}}
                                                      </span>
                                                       
                                                    </div>
                                                  </v-list-tile-sub-title>
                                                  <v-list-tile-sub-title>
                                                    <v-layout>
                                                      <div class="font-weight-bold caption">
                                                        {{$t('VKN-TC')}}: <span
                                                          v-if="item.GenelBilgileri.Cari.TCNo!=null">{{item.GenelBilgileri.Cari.TCNo}}</span>/
                                                        <span
                                                          v-if="item.GenelBilgileri.Cari.VergiNo!=null">{{item.GenelBilgileri.Cari.VergiNo}}</span>
                                                      </div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>
                                                  <v-list-tile-sub-title>
                                                    <div class="font-weight caption ">
                                                    </div>
                                                  </v-list-tile-sub-title>

                                                </v-list-tile-content>
                                              </v-list-tile>
                                            </v-card>
                                          </v-layout>
                                        </v-flex>

                                      </v-layout>
                                    </v-flex>


                                    <v-flex xs6 sm3 md2>
                                      <v-layout>
                                        <v-flex xs12 sm6 md6>
                                          <v-layout align-start="" justify-start fill-height>
                                            <v-card flat="">
                                              <v-list-tile>
                                                <v-list-tile-content style="'overflow=inherit';">
                                                  <v-list-tile-sub-title>
                                                    <div class="font-weight-bold caption ">
                                                      {{ $t('Amount') }}:
                                                    </div>
                                                  </v-list-tile-sub-title>
                                                  <v-list-tile-sub-title>
                                                    <div class="font-weight-bold  caption">
                                                      {{ $t('VAT') }}
                                                    </div>
                                                  </v-list-tile-sub-title>
                                                </v-list-tile-content>
                                              </v-list-tile>
                                            </v-card>
                                          </v-layout>
                                        </v-flex>

                                        <v-flex xs12 sm6 md6>
                                          <v-layout row justify-end="" fill-height>
                                            <v-card flat="">
                                              <v-list-tile>
                                                <v-list-tile-content>
                                                  <v-list-tile-sub-title>
                                                    <v-layout align-center="" justify-end>
                                                      <div class="font-weight-bold  caption ">
                                                        {{item.tutarlar.Tutar | moneyformat}}{{getparabirimi()}} </div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <v-layout align-center="" justify-end="">
                                                      <div class="font-weight-bold  caption ">
                                                        {{item.tutarlar.Kdv | moneyformat}}{{getparabirimi()}}
                                                      </div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>
                                                </v-list-tile-content>
                                              </v-list-tile>
                                            </v-card>
                                          </v-layout>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>

                                     <v-flex xs12 sm4 md1 xl2>
                                      <v-card flat="">
                                        <v-layout row wrap align-center="" justify-end="" fill-height="">

                                          <!-- <v-flex xs12 sm2 md2>
                                            <v-tooltip slot="append" bottom>
                                              <v-btn small v-if="item.GenelBilgileri.FaturaTip!='0'" slot="activator"
                                                icon class="mx-0"
                                                @click="onizleme(item.GenelBilgileri.EFaturaShowID.EFaturaGuid,item.GenelBilgileri.EFaturaShowID.EFaturaID)">
                                                <v-icon color="info">line_weight</v-icon>
                                              </v-btn>
                                              <span>deneme</span>
                                            </v-tooltip>
                                          </v-flex> -->
                                          <v-flex v-if="item.GenelBilgileri.InvoiceStatus!=null && item.GenelBilgileri.InvoiceStatus.includes('Reject')" xs12 sm2 md3 xl2>
                                            <v-tooltip bottom>
                                              <v-btn small icon :disabled="!sayfayetki.Update" slot="activator"
                                                @click="gitInvoiceStatus(item.GenelBilgileri)" flat>
                                                <v-icon color="red" dark>error</v-icon>
                                              </v-btn>
                                             
                                              <span v-if="sayfayetki.Update">Fatura Durum</span>
                                            </v-tooltip>
                                          </v-flex>


                                          <v-flex xs12 sm2 md3 xl2>
                                            <v-tooltip slot="append" bottom>
                                              <v-btn small v-if="item.GenelBilgileri.FaturaTip!='0'" slot="activator"
                                                icon class="mx-0"
                                                @click="efaturagoster(item.GenelBilgileri.EFaturaShowID.EFaturaGuid,item.GenelBilgileri.EFaturaShowID.EFaturaID)">
                                                <v-icon color="info">line_weight</v-icon>
                                              </v-btn>
                                              <span>{{ $t('E-Invoice') }} </span>
                                            </v-tooltip>
                                          </v-flex>

                                          <v-flex xs12 sm2 md3 xl2>
                                            <v-tooltip slot="append" bottom>
                                              <v-btn small icon slot="activator" class="mx-0"
                                                @click="reportbrobas(item.GenelBilgileri.EFaturaShowID.EFaturaGuid,item.GenelBilgileri.EFaturaShowID.EFaturaID,item.GenelBilgileri.EFaturaShowID.PdfID)">
                                                <v-icon color="info">print</v-icon>
                                              </v-btn>
                                              <span>{{ $t('Print') }}</span>
                                            </v-tooltip>
                                          </v-flex>

                                          <v-flex
                                            v-if="(item.GenelBilgileri.FaturaTip=='1' || item.GenelBilgileri.FaturaTip=='2') && item.GenelBilgileri.EFaturaShowID.FaturaStatus=='Fatura Beklemede'"
                                            xs12 sm2 md3 xl2>
                                            <v-tooltip bottom>
                                              <v-btn small icon :disabled="!sayfayetki.Update" slot="activator"
                                                @click="OnayaGonderTekli(item)" flat>
                                                <v-icon color="info" dark>check</v-icon>
                                              </v-btn>
                                              <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}( {{ $t('Send-for-Approval') }} )</span>
                                              <span v-if="sayfayetki.Update"> {{ 'Entegre Et' }} </span>
                                            </v-tooltip>
                                          </v-flex>

                                          <v-flex v-if="item.GenelBilgileri.Tip=='SER'" xs12 sm2 md3 xl2>
                                            <v-tooltip bottom>
                                              <v-btn small icon :disabled="!sayfayetki.Update" slot="activator"
                                                @click="git(item.GenelBilgileri)" flat>
                                                <v-icon color="info" dark>edit</v-icon>
                                              </v-btn>
                                              <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                                              <span v-if="sayfayetki.Update">{{ $t('Edit') }}</span>
                                            </v-tooltip>
                                          </v-flex>

                                          <v-flex v-if="item.GenelBilgileri.Tip=='SER'" xs12 sm2 md3 xl2>
                                            <v-tooltip bottom>
                                              <v-btn small icon :disabled="!sayfayetki.Update" slot="activator"
                                                @click="gitcopy(item.GenelBilgileri)" flat>
                                                <v-icon color="info" dark>library_add</v-icon>
                                              </v-btn>
                                              <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                                              <span v-if="sayfayetki.Update">Faturayı Kopyala</span>
                                            </v-tooltip>
                                          </v-flex>
                                          <v-flex v-if="item.GenelBilgileri.PdfLink!='' && item.GenelBilgileri.PdfLink!=null" xs12 sm2 md3 xl2>
                                            <v-tooltip bottom>
                                              <v-btn small icon  slot="activator"
                                                @click="gitpdflink(item.GenelBilgileri)" flat>
                                                <v-icon color="info" dark>download</v-icon>
                                              </v-btn>
                                            
                                              <span >PDF İndir</span>
                                            </v-tooltip>
                                          </v-flex>
                                          <v-flex xs12 sm2 md3 xl2>
                                            <v-tooltip slot="append" bottom>
                                              <a target="_blank" small slot="activator"
                                                v-bind:href="'#/fatura/faturadetay/id?' + 'guid=' + item.GenelBilgileri.EFaturaShowID.EFaturaGuid">
                                                <v-btn small icon>
                                                  <v-icon color="info">search</v-icon>
                                                </v-btn>
                                              </a>
                                              <span>  {{ $t('Content') }} </span>
                                            </v-tooltip>
                                          </v-flex>
                                          <v-flex v-if="item.GenelBilgileri.InvoiceStatus!=null && item.GenelBilgileri.InvoiceStatus.includes('Conditionally')" xs12 sm2 md3 xl2>
                                            <v-tooltip bottom>
                                              <v-btn small icon :disabled="!sayfayetki.Update" slot="activator"
                                                @click="gitInvoiceStatus(item.GenelBilgileri)" flat>
                                                <v-icon color="#EF6C00" dark>priority_high</v-icon>
                                              </v-btn>
                                             
                                              <span v-if="sayfayetki.Update">Fatura Durum</span>
                                            </v-tooltip>
                                          </v-flex>
                                        </v-layout>

                                      </v-card>
                                    </v-flex>
                                  </v-layout>
                                </v-card-actions>
                              </v-card>
                            </v-card>
                          </v-flex>
                        </v-layout>

                      </v-list>
                    </v-card>
                  </v-hover>
                </v-flex>




              </v-card>
            </v-flex>
          </v-layout>
          <v-container>
            <v-layout justify-center="">
              <template v-if="vmodelpagination">
                <div class="text-xs-center">
                  <v-container>
                    <v-layout justify-center>
                      <v-flex>
                        <v-pagination v-model="sayfalama" :length="pagenumber" :total-visible="7"></v-pagination>

                      </v-flex>
                    </v-layout>
                  </v-container>
                </div>
              </template>
            </v-layout>
          </v-container>
          <v-dialog v-model="dialoginvoicestatus" scrollable="" max-width="650px">
            <v-card flat color="grey lighten-5">
              <v-card-title> {{ $t('Invoice-Status') }} {{ this.InvoiceSatatusFat}} </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-flex xs12 sm12 md12>
                  <v-textarea label="Fatura Durumu" v-model="InvoiceSatatusDesc"></v-textarea>
                </v-flex>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="dialoginvoicestatus=false">{{$t('Close')}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogaciklama" scrollable="" max-width="300px">
            <v-card flat color="grey lighten-5">
              <v-card-title> {{ $t('Fields-Inquired') }} </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-flex xs12 sm12 md12>
                  <template v-for="item in aramatipi">
                    <v-layout row wrap v-bind:key="item.id">
                      <v-flex xs1 sm1 md1>
                        <v-layout column="" align-start>
                          <v-list-tile>
                            <v-list-tile-content>
                              <v-layout column justify-start="" align-start>
                                -
                              </v-layout>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-layout>
                      </v-flex>

                      <v-flex xs4 sm11 md11>
                        <v-layout column="" align-start>
                          <v-list-tile>
                            <v-list-tile-content>
                              <v-layout column justify-start="" align-start>
                                {{item.text}}
                              </v-layout>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </template>
                </v-flex>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="dialogaciklama=false">{{$t('Close')}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>


          <v-dialog v-model="dialogsor" persistent max-width="290">
            <v-card>
              <v-card-title class="headline">{{ $t('Warning') }} !</v-card-title>
              <v-card-text>{{$t('Are-you-sure-you-want-to-cancel-selected-invoices?')}}</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="info" flat @click.native="dialogsor=false">{{$t("cancel_button")}}</v-btn>
                <v-btn color="info" :disabled="islemstatus" flat @click="faturaiptalet()">{{ $t('OK') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogOnizleme" max-width="700">
            <iframe scrolling="yes" id="denemem" src="" height="800" width="700" type="application/pdf">
            </iframe>

          </v-dialog>


          <v-dialog v-model="dialogfiltre" scrollable persistent="" max-width="510px">

            <v-card>
              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>

                <v-card flat="" class="white--text">
                  <v-card flat="">
                    <v-card-actions>
                      <v-layout row="" wrap="">
                        <v-flex xs12 v-if="filtreUyari" sm12 md12>

                          <v-layout align-start="" justify-start="" fill-height="">
                            <v-icon color="red">warning</v-icon> &nbsp;
                            <span class="subheading red--text font-weight-bold">
                             {{ $t('continue-with-Apply-Filters-option') }}
                            </span>
                          </v-layout>
                        </v-flex>


                        <v-flex xs12 pt-2 v-if="filtrefaturatipfaturaView" sm12 md12>
                          <v-layout align-center="">
                            <span class="subheading grey--text font-weight-">
                              <ul>
                                <li> {{ $t('Invoice-Type-All-and-Except-Paper-Invoice') }}  &nbsp; </li>
                              </ul>
                            </span>
                            <v-icon v-show="filtrefaturatipfatura" color="green">done_outline</v-icon>
                          </v-layout>
                          <v-layout align-center="">
                            <span class="subheading grey--text font-weight-">
                              <ul>
                                <li> {{ $t('Invoice-Status-Invoice-on-Hold') }}  &nbsp; </li>
                              </ul>
                            </span>
                            <v-icon v-show="filtrefaturastatus" color="green">done_outline</v-icon>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 pt-4 sm12 md12>
                          <v-layout align-start="" justify-start="" fill-height="">
                            <v-icon color="info">filter_list</v-icon> &nbsp;
                            <span class="subheading info--text font-weight-">
                              {{ $t('Filters') }}
                            </span>
                          </v-layout>
                          <v-divider></v-divider>
                        </v-flex>
                        <v-flex xs12 sm6 md6>
                          <v-text-field hide-details="" v-model="SerbestFatura.BaslangicFaturaNo" :label="$t('Invoice-No') + '-1'"
                            required> </v-text-field>
                        </v-flex>

                        <v-flex xs12 sm6 md6>
                          <v-text-field hide-details="" v-model="SerbestFatura.BitisFaturaNo" :label="$t('Invoice-No') + '-2'"
                            required>
                          </v-text-field>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                           <cariaracomp  v-bind:etiket="$t('Accound-Code')"  v-bind:value="SerbestFatura.Cari.Kod" v-model="SerbestFatura.Cari.Kod"></cariaracomp>
                        </v-flex>

                        <v-flex xs12 sm6 md6>
                          <parainput :detaygizle="true" :simge="getparabirimi()" style="padding-right:3px;"
                            v-model="SerbestFatura.MinTutar" :etiket="$t('Min-Amount')" :autocomplete="autocomplete">
                          </parainput>
                        </v-flex>

                        <v-flex xs12 pb-1 sm6 md6>
                          <parainput :detaygizle="true" :simge="getparabirimi()" :name="maxtutar"
                            v-model="SerbestFatura.MaxTutar" :etiket="$t('Max-Amount')" :autocomplete="autocomplete">
                          </parainput>
                        </v-flex>

                        <v-flex pt-4 xs12 sm12 md12>
                          <v-layout align-start="" justify-start="" fill-height="">

                            <v-icon color="info">settings</v-icon> &nbsp;
                            <span class="subheading info--text font-weight-">
                              {{$t('Options')}} </span>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-select :label="$t('Invoice-Status')" hide-details v-model="SerbestFatura.FaturaStatusTip"
                            :loading="loading" :items="itemsstatus" item-text="text" cache-items="" item-value="value">
                          </v-select>
                        </v-flex>


                        <v-flex xs12 sm12 md6>
                          <v-radio-group hide-details="" v-model="SerbestFatura.EfaturaTip" :label="$t('Invoice-Type')" column>
                            <v-radio :label="$t('Only-Paper-Invoice')" value="1"> </v-radio>
                            <v-radio label="Sadece E-Fatura" value="2"></v-radio>
                            <v-radio label="Sadece E-Arşiv" value="3"></v-radio>
                            <!-- <v-radio label="E-Fatura ve E-Arşiv" value="4"></v-radio> -->
                          </v-radio-group>
                        </v-flex>
                        <v-flex xs12 sm12 md6>
                          <v-radio-group hide-details="" v-model="SerbestFatura.FaturaTp" :label="$t('Invoice-Type')" column>
                            <v-radio :label="$t('All')" value="H"> </v-radio>
                            <v-radio :label="$t('Free')" value="S"></v-radio>
                            <v-radio :label="$t('Ticket')" value="B"></v-radio>
                            <v-radio label="Coper" value="c"></v-radio>
                          </v-radio-group>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-checkbox label="Entegre Edilenler" hide-details="" v-model="SerbestFatura.EntegreEdilenler">
                          </v-checkbox>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-checkbox :label="$t('Use-Due-Date')" hide-details="" v-model="SerbestFatura.VadeTarihi">
                          </v-checkbox>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-checkbox :label="$t('Show-Only-Invoices-Balance')" hide-details=""
                            v-model="SerbestFatura.Bakiyeli"></v-checkbox>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-checkbox :label="$t('Show-Free-Invoices-Registered-Current')" hide-details=""
                            v-model="SerbestFatura.CariyeKaydedilmeyen"></v-checkbox>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-checkbox :label="$t('All-Companies')" hide-details="" v-model="tumsirketler"></v-checkbox>
                        </v-flex>
                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{ $t('cancel_button') }} </v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
              </v-card-actions>
            </v-card>


          </v-dialog>
          <v-dialog v-model="dialogsonucv2" scrollable persistent="" max-width="800px">

<v-card flat>
  <v-card-title> 
    <v-toolbar size="120px" dark color="info">
                <v-toolbar-title class="baslikfont"> Entegrasyon Sonucu
                </v-toolbar-title>
                <v-spacer></v-spacer>
                    
                       
                </v-toolbar>     
  </v-card-title>
  <v-divider></v-divider>
  <v-card-text>

    <v-card>
      <v-card flat="">
        <v-card-actions>
          <v-layout row="" wrap="">
          

         


          

            <v-flex pb-2  xs12 sm6 md6>
                <span  class="green--text px-12"> {{ $t('Successful') }} {{  ':' }}  {{ this.entegrasyonBasariliSayi}} {{  ' / ' }} </span>
                
                <span  class="red--text px-20"> {{ $t('Unsuccessful') }} {{  ':' }} {{ this.entegrasyonBasarisizSayi}} </span> 
            </v-flex>
           
            <v-divider></v-divider>


          

          
            <v-flex xs12 sm12 md12>
              <v-card flat>
                <v-data-table :headers="headerssonuc" :rows-per-page-items=[50,100] :items="successIntegrates" item-key="BiletNo">
                  <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                  <template slot="items" slot-scope="props">
                    <td class="text-xs-left">{{ props.item.BiletNo  }}</td>
                    <td v-if="props.item.Error==false" class="text-xs-left"><span
                        class="green--text"> {{ $t('Successful') }} </span></td>
                    <td v-if="props.item.Error==true" class="text-xs-left"><span
                        class="red--text"> {{ $t('Unsuccessful') }}  </span></td>
                    <td class="text-xs-left">{{ props.item.ErrorMessage }}</td>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-card>
  </v-card-text>
  <v-divider></v-divider>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn color="blue darken-1" flat @click.native="dialogsonuciptalv2()">Kapat</v-btn>
  </v-card-actions>
</v-card>


</v-dialog>
          <v-dialog v-model="dialogsonuc" scrollable persistent="" max-width="600px">

            <v-card flat>
              <v-card-title>  {{ 'E-Fatura / E-Arşiv Entegrasyon Sonuçları' }} 
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>

                <v-card>
                  <v-card flat="">
                    <v-card-actions>
                      <v-layout row="" wrap="">
                        <v-flex xs6 v-if="archiveProgress">
                          <v-flex xs6  class="headline">
                              E-Arsiv
                          </v-flex>
                          <v-flex xs6>
                            <v-progress-circular
                              :size="150"
                              :width="10"
                              :color="eArchiveColor"
                              indeterminate
                            >
                              {{ eArchiveLoadingCount }}  / {{ eArchiveTotalCount }}
                            </v-progress-circular>
                          </v-flex>
                        </v-flex>

                        <v-flex xs6 v-if="billProgress">
                            
                          <v-flex xs6  class="headline">
                           {{ $t('E-Invoice') }} 
                          </v-flex>
                          <v-flex xs6>
                            <v-progress-circular
                              :size="150"
                              :width="10"
                              :color="eBillColor"
                              indeterminate
                            >
                              {{ eBillLoadingCount }}  / {{ eBillTotalCount }}
                            </v-progress-circular>
                          </v-flex>

                        </v-flex>


                        <v-flex xs12 pt-2>
                          
                        </v-flex>

                        <v-flex pb-2  xs12 sm12 md12>
                          <v-toolbar size="120px" dark color="info">
                            <v-toolbar-title class="baslikfont"> E-Fatura Entegrasyon Sonucu
                            </v-toolbar-title>
                            <v-spacer></v-spacer>

                          </v-toolbar>

                        </v-flex>
                        <v-divider></v-divider>


                        <v-flex xs12 sm12 md12>
                          <v-card flat>
                            <v-data-table :headers="headerssonuc" :rows-per-page-items=[50,100] :items="itemsefatura" item-key="name">
                              <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                              <template slot="items" slot-scope="props">
                                <td v-if="props.item.OperationCompleted==true" class="text-xs-left"><span
                                    class="green--text"> {{$t('Successful') }} </span></td>
                                <td v-if="props.item.OperationCompleted==false" class="text-xs-left"><span
                                    class="red--text"> {{ $t('Unsuccessful') }} </span></td>
                                <td class="text-xs-left">{{ props.item.guid  }}</td>
                                <td class="text-xs-left">{{ props.item.error }}</td>

                              </template>
                              <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                 {{ $t('No-records-searched-for', { value: search3}) }}
                              </v-alert>
                            </v-data-table>
                          </v-card>

                        </v-flex>

                        <v-flex pb-2 xs12 sm12 md12>
                          <v-toolbar size="120px" dark color="info">
                            <v-toolbar-title class="baslikfont"> E-Arşiv Entegrasyon Sonucu
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                          </v-toolbar>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-card flat>
                            <v-data-table :headers="headerssonuc" :rows-per-page-items=[50,100] :items="itemsearsiv" item-key="name">
                              <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                              <template slot="items" slot-scope="props">

                                <td v-if="props.item.OperationCompleted==true" class="text-xs-left"><span
                                    class="green--text"> {{ $t('Successful') }} </span></td>
                                <td v-if="props.item.OperationCompleted==false" class="text-xs-left"><span
                                    class="red--text"> {{ $t('Unsuccessful') }}  </span></td>
                                <td class="text-xs-left">{{ props.item.guid  }}</td>
                                <td class="text-xs-left">{{ props.item.error }}</td>

                              </template>
                              <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                   {{ $t('No-records-searched-for', { value: search3}) }}
                              </v-alert>
                            </v-data-table>
                          </v-card>

                        </v-flex>

                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="dialogsonuciptal()">Islemi Sonlandir</v-btn>

              </v-card-actions>
            </v-card>


          </v-dialog>


          <v-dialog v-model="faturaserinoDialog" scrollable persistent="" max-width="300px">
            <v-card color="grey lighten-5">

              <v-card-title>Fatura Seri/No Değiştir</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-form ref="formserino" v-model="valid" lazy-validation>
                  <v-layout row="" wrap="">
                    <v-flex xs12 sm12 md12>
                      <v-text-field mask="AAAAAAAAAAAAAAAA" :rules="[v => !!v || 'Lütfen seri giriniz']"
                        :label="$t('Invoice-Serial')" v-model="Faturaseri" required></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md12 v-if="faturaNoCheck == true">
                      <v-text-field :label="$t('Invoice-No')" mask="##################" :rules="[v => !!v || $t('Please-enter-your-invoice-number')]"
                        v-model="Faturano">
                      </v-text-field>
                    </v-flex>
                       <v-flex xs12 sm12 md12 v-if="faturaNoCheck == false">
                      <v-text-field :label="$t('Invoice-No')" mask="#########"   :rules="[v => !!v || $t('Please-enter-your-invoice-number')]"
                        v-model="Faturano">
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="faturaserinoDialog=false">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click="faturaserinodegistir()">{{ $t('Change') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

        </v-layout>
      </v-card>
    </v-app>

    <loadingcomp :mesaj="loadingmesaj" v-model="islemstatus"></loadingcomp>
 
    <v-dialog v-model="faturadialog" :scrollable="false" max-width="850px">
      <v-card>
        <v-card-title> {{ $t('E-Invoice') }}  </v-card-title>
        <v-divider></v-divider>
        <v-card-text>


          <v-layout  justify-end row wrap="">
             <v-btn outline  @click="denemeyazdir('demo2')" color="info"><v-icon>print</v-icon></v-btn>

            <div class="ScrollStyle1"  id="demo2" height="700px;" width="100%"></div>
            <!-- <iframe scrolling="yes" id="demo2" src="" height="700" width="100%"> </iframe> -->

          </v-layout>


        </v-card-text>
      </v-card>
    </v-dialog>


  </div>


</template>


<script>
  import auth from '../../../api/auth'
  import parainput from '../customcomp/parainput'
  import reportbrosablon from "@/components/app/coper/comp/reportbrosablon.vue";
  import helpers from "@/components/app/customcomp/helpers.js"
  import tarihcomp from "@/components/app/customcomp/tarihim"
  import tool from "../coper/tools";
  import loadingcomp from "@/components/app/customcomp/loadingcomp"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import faturaviewer from "@/components/app/customcomp/faturaviewer.vue";
  import cariaracomp from '@/components/app/customcomp/cariaracomp.vue'
  import snackbarcomp from "@/components/app/customcomp/snackbarcomp";



  export default {
    data() {
      return {
        headerssonuc: [{
            text: 'Fatura No',
          }, 
          {
            text: 'Başarılı',
            value: 'Error'
          },
          {
            text: this.$t('Result'),
            value: 'ErrorMessage'
          }
        ],
        successIntegrates:[],
        entegrasyonBasariliSayi:0,
        entegrasyonBasarisizSayi:0,
        InvoiceSatatusFat:'',
        InvoiceSatatusDesc:'',
        dialoginvoicestatus:false,
        itemsstatus: [{
          value: 0,
          text: this.$t('All')
        }, {
          value: 1,
          text: this.$t('Fatura Beklemede')
        }, {
          value: 2,
          text: this.$t('Fatura Gönderildi')
        }, {
          value: 3,
          text: this.$t('Alıcı Onayladı')
        }, ],
        loadingmesaj: '',
        loadingdialog: false,
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        islemstatus: false,
        filtrevarmi: false,
        dialogaciklama: false,
        aramatipi: [{
            value: '-',
            text: this.$t('Invoice-Number-v2')
          },
          {
            value: '-',
            text: this.$t('Currentcode_label')
          },
          {
            value: '-',
            text: this.$t('Current-Title')
          }, {
            value: '-',
            text: this.$t('Taxnumber_label')
          }, {
            value: '-',
            text: this.$t('Identitynumber_label')
          },
          {
            value: '-',
            text: 'Guid'
          }, {
            value: '-',
            text: this.$t('Invoice-Total-Amount')
          }
        ],
        searchliste: null,
        dialogOnizleme: false,
        itemsefatura: [],
        itemsearsiv: [],
        dialogsonuc: false,
        filtreUyari: false,
        filtretip: '0', // 0:standart, 1: Onaya gönder
        filtrefaturatipfatura: false,
        filtrefaturastatus: false,
        filtrefaturatipfaturaView: false,
        headerssonuc: [{
            text: this.$t('Result'),

          }, {
            text: 'Guid',
            value: 'guid'
          },
          {
            text: this.$t('Result'),
            value: 'error'
          }
        ],

        headers: [{
            text: this.$t('Invoice-Serial'),
            value: 'FaturaSeri',
            width: '10'
          },
          {
            text: this.$t('Invoice-No'),
            value: 'Faturano',
            width: '10'
          },
          {
            text: this.$t('Invoice-Date'),
            value: 'FaturaTarih'
          },
          {
            text: this.$t('Invoice-Type'),
            value: 'Tip'
          },
          {
            text: this.$t('Maturity-Date'),
            value: 'FaturaVade'
          },
          {
            text: this.$t('Remaining'),
            value: 'Kalan'
          },
          {
            text: this.$t('Amount'),
            value: 'Tutar'
          },
          {
            text: this.$t('VAT'),
            value: 'Kdv'
          },
          {
            text: 'Cari',
            value: 'Cari.Kod'
          }

        ],
        aramayapildi: false,
        pagem: 1,
        dialogsonucv2:false,
        dialogsor: false,
        valid: true,
        dizayn: null,
        vmodelpagination: false,
        serbestAdet: 0,
        coperAdet: 0,
        biletAdet: 0,
        ToplamAdetbilcopser: 0,
        kagıtAdet: 0,
        efaturaAdet: 0,
        earsivAdet: 0,
        ToplamAdetkagefatears: 0,
        toplamKDV: 0,
        ToplamMatrah: 0,
        ToplamKDVMat: 0,
        tumunuseckaldir: false,


        siralamatipi: 'InvoiceDate',
        kayitsayisi: 0,
        kayitadet: 50,
        recordcount: null,
        kayitvarmi: true,
        listegorunum: true,
        gorunumtipi: 'list',
        tablegorunum: false,
        kayitsayisivmodel: 50,
        kayitsayisi: [{
          text: '50',
          value: 50
        }, {
          text: '100',
          value: 100
        }],
        siralamavmodel: 0,
        siralamatipiitems: [
        {
          text: this.$t('Invoice-No'),
          value: 'InvoiceNo'
        },
          {
          text: this.$t('Date-Ascending'),
          value: 'InvoiceDate'
        }, {
          text: this.$t('Date-Descending'),
          value: 'InvoiceDateDesc'
        }, {
          text: this.$t('Current-Ascending'),
          value: 'InvoiceCurrentCode'
        }, {
          text: this.$t('Current-Descending'),
          value: 'InvoiceCurrentCodeDesc'
        }, {
          text: this.$t('Increasing-per-Amount'),
          value: 'InvoiceAmount'
        }, {
          text: this.$t('Decreasing-per-Amount'),
          value: 'InvoiceAmountDesc'
        }, ],

        filtreticket: [],
        indexsayisi: 10,
        pagenumber: 1,
        sayfalama: 1,
        secilenkayitlar: [],
        tooltip: false,
        el: null,
        SerbestFatura: {
          EntegreEdilenler:false,
          SirketKodu: null,
          BaslangicTarih: null,
          BitisTarih: null,
          TextSearch: null,
          BaslangicFaturaNo: null,
          BitisFaturaNo: null,
          Cari: {
            Kod: null
          },
          MinTutar: 0,
          MaxTutar: 0,
          VadeTarihi: false,
          Bakiyeli: false,
          CariyeKaydedilmeyen: false,
          FaturaTp: 'H',
          FaturaStatusTip: 0,
          EfaturaTip: '2',
          Paging: {
            SayfaNo: 1,
            VeriAdet: 50,
            SiralamaTip: 'InvoiceDate'
          }

        },
        Faturano: null,
        Faturaseri: null,
        faturaserinoDialog: false,
        faturaNoCheck:true,
        faturadialog: false,
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        date2yedek: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        loading: false,
        loading1: false,
        search3: '',
        renk: 'white',
        renk1: 'info',
        items: [],
        load: false,
        load1: true,
        butondurum: true,
        hesapkodu: [],
        anahesap: [],
        hesapgurubu: [],
        e6: [],
        tumsirketler: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        search: '',
        search1: '',
        cariKod: '',
        progress: false,


        dictionary: {
          custom: {

            tarihsecbas: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsecbit: {
              required: () => this.$t('Please-select-a-date')
            },
          }
        },

        maxtutar: 'maxtutar',
        autocomplete: 'autocomplete',
        etiket: 'Max Tutar',
        dialogfatura: false,
        mintutar: 'mintutar',
        etiketmin: 'Min Tutar',
        eBillFirstNumber: 0,
        eBillLastNumber: 2,
        eBillTotalCount:0,
        eBillLoadingCount:0,
        eArchiveTotalCount:0,
        eArchiveFirstNumber:0,
        eArchiveLastNumber:2,
        eArchiveLoadingCount:0,
        eArchiveColor:'green',
        eBillColor: 'green',
        billProgress:false,
        archiveProgress:false,
        dialogProgress:false,
        filtre: {
          a: '',
          b: '',
          c: ''
        },
        dialogfiltre: false,

      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      },
      bakiyekontrolsimgeli: function (m) {
        return helpers.bakiyekontrolsimgeli(m);
      }

    },
    mounted() {
      this.el = this.$refs.fab.$el

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)
      this.sayfayetki.Status=true;
      this.sayfayetki.Screen= true;
      this.sayfayetki.Update= true;
      this.sayfayetki.Save= true;
      this.sayfayetki.Delete= true;
        
      if (this.sayfayetki.Status == true) {
        this.kayitvarmi = false;
        this.vmodelpagination = false;
        this.recordcount = ""
        this.load1 = false
        this.date = helpers.getDateNow()
        this.date2 = helpers.getDateNow()

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.SerbestFatura.SirketKodu = credentials.SirketKodu
        this.SerbestFatura.BaslangicTarih = this.date
        this.SerbestFatura.BitisTarih = this.date2
        this.SerbestFatura.Paging.VeriAdet = 50
        this.SerbestFatura.Paging.SiralamaTip = 'InvoiceDate'
        this.SerbestFatura.Paging.SayfaNo = 1
        this.yedekfaturaclass = this.SerbestFatura;

        this.yedekListInput = this.SerbestFatura;

        var params = this.SerbestFatura


        this.$http.post(auth.API_URL + 'api/Report/Invoice3rdIntegrateReport', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          this.load1 = true

          if (response.body.FaturaBilgi.length > 0) {
            this.kayitvarmi = true;
            this.aramayapildi = true;
            this.pagenumber = response.body.TotalPage;
            this.vmodelpagination = true;
            this.recordcount = this.$t('Total') + response.body.TotalCount + this.$t('');

            this.items = response.body.FaturaBilgi

            this.serbestAdet = response.body.FaturaToplamlar.SerbestFaturaAdet;
            this.coperAdet = response.body.FaturaToplamlar.CoperFaturaAdet;
            this.biletAdet = response.body.FaturaToplamlar.BiletFaturaAdet;
            this.ToplamAdetbilcopser = response.body.FaturaToplamlar.ToplamFaturaAdet;
            this.kagıtAdet = response.body.FaturaToplamlar.FaturaAdet;
            this.efaturaAdet = response.body.FaturaToplamlar.EFaturaAdet;
            this.earsivAdet = response.body.FaturaToplamlar.EArsivAdet;
            this.ToplamAdetkagefatears = response.body.FaturaToplamlar.ToplamFaturaAdet;
            this.toplamKDV = response.body.FaturaToplamlar.ToplamKdv
            this.ToplamMatrah = 0;
            this.ToplamKDVMat = response.body.FaturaToplamlar.ToplamTutar

            var editdizi = []

            this.items.forEach(element => {

              var yenikayit = [];

              yenikayit.GenelBilgileri = element;

              var tutarlar = {
                Tutar: element.Tutar,
                KalanTutar: element.Kalan,
                Kdv: element.Kdv
              }

              yenikayit.tutarlar = tutarlar;

              var tarih = {
                FaturaTarihi: tarihkontrol(element.FaturaTarih),
              }

              yenikayit.TarihBilgileri = tarih;

              editdizi.push(yenikayit)
            });

            this.items = editdizi;
            this.load1 = true
            this.vmodelpagination = true;

          } else {
            this.kayitvarmi = false;
            this.load1 = true
            this.vmodelpagination = false;
            this.recordcount = ""
            this.text1 = this.$t('No-Records-Found')
            this.snackbar = true
          }

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true

          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true

          }
        })


      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          } 

        });

      }
    },
    components: {
      'parainput': parainput,
      reportbrosablon,
      tarihcomp,
      loadingcomp,
      yetkidialog,
      faturaviewer,
      cariaracomp,
      snackbarcomp
    },
    watch: {
      'filtrefaturatipfatura': function (value) {
        // fatura tipini seç
      },
      'SerbestFatura.FaturaStatusTip': function (value) {
        if (value == 1) {
          this.filtrefaturastatus = true
        } else {
          this.filtrefaturastatus = false
        }
      },
      'SerbestFatura.EfaturaTip': function (value) {
        if (value != '0' && value != '1') {
          this.filtrefaturatipfatura = true
        } else {
          this.filtrefaturatipfatura = false
        }
      },
      'kayitadet': function (valueveriadet) {
        this.getList(1, valueveriadet, this.siralamatipi, false)
      },

      'siralamatipi': function (tip) {
        this.sayfalama = 1;
        this.getList(1, this.kayitadet, tip, false)
      },
      'sayfalama': function (sayfa) {

        this.getList(sayfa, this.kayitadet, this.siralamatipi, false)
      },
      'secilenkayitlar': function (value) {
          
        // if (value.length > 0) {
        //   var kayitno = value.length - 1
        //   if (value[kayitno].GenelBilgileri.Tip == 'SER' || value[kayitno].GenelBilgileri.EFaturaShowID
        //     .FaturaStatus ==
        //     'Alıcı Onayladı') {
        //     this.secilenkayitlar.splice(value.length - 1, 1)
        //     this.text1 = "Serbest Fatura veya Onaylanmış Faturalara toplu işlem yapamazsınız."
        //     this.snackbar = true
        //   } else {

        //   }
        //}

      },
      tumunuseckaldir(valsec) {

        if (valsec == true && this.aramayapildi == true) {
          this.islemstatus = true;
          this.yedekListInput.Paging.SayfaNo = 0
          this.yedekListInput.Paging.VeriAdet = null
          this.yedekListInput.Paging.SiralamaTip = null
          this.yedekListInput.BaslangicTarih = this.date
          this.yedekListInput.BitisTarih = this.date2
          var params = this.yedekListInput

          this.$http.post(auth.API_URL + 'api/Report/Invoice3rdIntegrateReport', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

            if (response.body.FaturaBilgi.length > 0) {
              this.kayitvarmi = true;
              var editdizi = []

              response.body.FaturaBilgi.forEach(element => {

                if (element.Tip == 'SER' || element.EFaturaShowID.FaturaStatus == 'Alıcı Onayladı') {

                } else {
                  //normalde burda bu kodlar
                }

                var yenikayit = [];
                yenikayit.GenelBilgileri = element;
                var tutarlar = {
                  Tutar: element.Tutar,
                  KalanTutar: element.Kalan,
                  Kdv: element.Kdv,
                }
                yenikayit.tutarlar = tutarlar;
                var tarih = {
                  FaturaTarihi: tarihkontrol(element.FaturaTarih),
                }
                yenikayit.TarihBilgileri = tarih;
                editdizi.push(yenikayit)

              });

              this.secilenkayitlar = editdizi;
              this.secilenkayitlaryedek = editdizi
              this.aramayapildi = false;
              this.progress = false
              this.load1 = true
              this.vmodelpagination = true;
              this.islemstatus = false;

            } else {
              this.kayitvarmi = false;
              this.load1 = true
              this.items = [];
              this.vmodelpagination = false;
              this.recordcount = ""
              this.text1 = this.$t('No-Records-Found')
              this.snackbar = true
              this.islemstatus = false;
   
            }
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.progress = false
              this.load1 = true
              this.islemstatus = false;
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.progress = false
              this.load1 = true
              this.islemstatus = false;
            }
          })
        } else if (this.aramayapildi == false && valsec == true) {
          //this.secilenkayitlar = this.secilenkayitlaryedek;
         //Toplam kayit sayisini yanlis gosterdigi icin ustteki if buraya alindi this.aramayapildi bir cok yere bagli oldugu icin ayarlar degistirilmedi.
          this.islemstatus = true;
          this.yedekListInput.Paging.SayfaNo = 0
          this.yedekListInput.Paging.VeriAdet = null
          this.yedekListInput.Paging.SiralamaTip = null
          this.yedekListInput.BaslangicTarih = this.date
          this.yedekListInput.BitisTarih = this.date2
          var params = this.yedekListInput

          this.$http.post(auth.API_URL + 'api/Report/Invoice3rdIntegrateReport', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

            if (response.body.FaturaBilgi.length > 0) {
              this.kayitvarmi = true;
              var editdizi = []

              response.body.FaturaBilgi.forEach(element => {

                if (element.Tip == 'SER' || element.EFaturaShowID.FaturaStatus == 'Alıcı Onayladı') {

                } else {
                  //normalde burda bu kodlar
                }

                var yenikayit = [];
                yenikayit.GenelBilgileri = element;
                var tutarlar = {
                  Tutar: element.Tutar,
                  KalanTutar: element.Kalan,
                  Kdv: element.Kdv,
                }
                yenikayit.tutarlar = tutarlar;
                var tarih = {
                  FaturaTarihi: tarihkontrol(element.FaturaTarih),
                }
                yenikayit.TarihBilgileri = tarih;
                editdizi.push(yenikayit)

              });

              this.secilenkayitlar = editdizi;
              this.secilenkayitlaryedek = editdizi
              this.aramayapildi = false;
              this.progress = false
              this.load1 = true
              this.vmodelpagination = true;
              this.islemstatus = false;

            } else {
              this.kayitvarmi = false;
              this.load1 = true
              this.items = [];
              this.vmodelpagination = false;
              this.recordcount = ""
              this.text1 = this.$t('No-Records-Found')
              this.snackbar = true
              this.islemstatus = false;
   
            }
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.progress = false
              this.load1 = true
              this.islemstatus = false;
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.progress = false
              this.load1 = true
              this.islemstatus = false;
            }
          })


        } else if (this.aramayapildi == false && valsec == false) {
          this.secilenkayitlar = [];
        }

      },
    },
    computed: {
  sortedArray: function() {
    function compare(a, b) {
     
     return a.GenelBilgileri.Faturano - b.GenelBilgileri.Faturano
    }
   
    if (this.siralamatipi=='InvoiceDate' || this.siralamatipi=='InvoiceNo')
      {
        
         return this.items.sort(compare);
    }
    else{
      return this.items;
    }
  }
},
    methods: {
      denemeyazdir(divName) {

        var mywindow = window.open('', 'PRINT', 'height=500,width=700');
        mywindow.document.write('</head>');
        mywindow.document.write('<style>');
        //yazdırılmayacak alanlar için css ekliyorum
        mywindow.document.write('@media print{.no-print {display:none !important;}}');
        mywindow.document.write('table{font-size:9px;border-collapse: collapse;}');
        mywindow.document.write('</style>');
        //   mywindow.document.write('<body >');
        mywindow.document.write(document.getElementById(divName).innerHTML);
        // mywindow.document.write('</body></html>');

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/

        mywindow.print();
        mywindow.close();

        return true;

      },
      getparabirimi() {
        return helpers.getparabirimi()
      },
      onizleme(guid, id) {
        var prm = {
          id: id,
          guid: guid
        };

        this.$refs.faturaviewer.open(prm, 0).then(confirm => {
          if (confirm !== "") {
            //
          }
        });
      },
      dialogac() {
        this.dialogaciklama = true
      },
      faturaarama(a) {

        this.getList(1, this.kayitadet, this.siralamatipi, true, a)
      },
      serbestfaturaEkle() {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var params = {
          MusteriID: credentials.MusteriID,
          HareketTip: 'Fatura',
          HareketSayisi: 1
        }

        this.$http.post(auth.API_URL + 'api/Register/PackageCustomerInfos', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          if (response.body.UyelikStatus == true) {

            if (response.body.KontorStatus == true) {

              var url = '#/fatura/serbestfatura/id?islem=yeni'
              window.open(url, '_self')


            } else {
              this.text1 = this.$t('not-process-need-purchase-continue-process')
              this.snackbar = true
            }

          } else {
            this.text1 = this.$t('membership-expired-need-renew-membership-process')
            this.snackbar = true
          }


        }, (response) => {

          if (response.status === 0) {
            this.text1 = 'Service Unavailable-ProductCustomerInfo'
            this.snackbar = true
            islemok = false
          } else {
            this.text1 = 'Service Unavailable-ProductCustomerInfo'
            this.snackbar = true
          }
        })

      },
     
      OnayaGonderTekli(item) {
        this.islemstatus = true
        var prm = {
          faturaTip: item.GenelBilgileri.FaturaTip,
          faturaList: []
        };
        prm.faturaList.push({
          id: item.GenelBilgileri.EFaturaShowID.EFaturaID,
          guid: item.GenelBilgileri.EFaturaShowID.EFaturaGuid
        });
        tool.api_post(this, "EFatura/EFatura23rdEntegreGonder", prm).then(
          response => {
            if (response.body.Status==false)
          {
            this.text1 = response.body.Returns[0].ErrorMessage;
            this.snackbar = true
          }
          else
          {
            this.text1 = response.body.Returns[0].SuccessMessage; 
            this.snackbar = true
          }
             
              this.getList(1, 50, 'InvoiceDate', true)
              this.islemstatus = false;
          },
          response => {
            this.islemstatus = false
            this.status = tool.responseToStatus(response);
          }
        );
      },
      onayaGonderToplusor() {
        this.filtrefaturatipfaturaView = true
        this.filtretip = '1'
        this.dialogfiltre = true
        this.filtreUyari = true
        this.SerbestFatura.FaturaStatusTip = 1
      },
      stopBilling(){
          // this.dialogProgress = false;
          this.dialogsonuc = false;
          this.billProgress = false;
          this.archiveProgress = false;
          this.eArchiveLastNumber = this.eArchiveTotalCount;
          this.eBillLastNumber = this.eBillTotalCount;
          
      },
      sendEArchive(firstNumber,lastNumber,totalCount,billList){
            var sendList = billList.slice(firstNumber,lastNumber);

            var prm1 = {
              faturaTip: '2',
              faturaList: sendList
            };

            tool.api_post(this, "EFatura/EFatura23rdEntegreGonder", prm1).then(
              response => {
                this.islemstatus = false;
                this.eArchiveLoadingCount = lastNumber;

                if(this.eArchiveLastNumber >= this.eArchiveTotalCount){
                    this.getList(1, 50, 'InvoiceDate', true)
                    response.body.forEach(element => {
                      this.itemsearsiv.push(element); 
                    });
                    this.archiveProgress = false;
          
                }else{
                  var checkLastActions = totalCount - lastNumber ;
                  this.eArchiveFirstNumber = this.eArchiveLastNumber;
                  
                  if(checkLastActions > 0 && 2 > checkLastActions){

                  response.body.forEach(element => {
                      this.itemsearsiv.push(element); 
                  });

                  this.eArchiveLastNumber = checkLastActions + this.eArchiveLastNumber;
                  this.sendEArchive(this.eArchiveFirstNumber,this.eArchiveLastNumber,totalCount,billList);

                  }else{
                  response.body.forEach(element => {
                      this.itemsearsiv.push(element); 
                  });

                  this.eArchiveLastNumber = 2 + this.eArchiveLastNumber;
                  this.sendEArchive(this.eArchiveFirstNumber,this.eArchiveLastNumber,totalCount,billList);
               
                  }
            
                }
                
              },
              response => {
                this.islemstatus = false;
                let itemError = {
                  OperationCompleted : false,
                  guid: 0 ,
                  error:response.body.MessageDetail
                }
                this.eArchiveColor = 'red';
                this.itemsearsiv.push(itemError); 
                this.status = tool.responseToStatus(response);
              }
            );

      },
      sendEbill(firstNumber,lastNumber,totalCount,billList){

            var sendList = billList.slice(firstNumber,lastNumber);

            var prm1 = {
              faturaTip: '1',
              faturaList: sendList
            };

            //this.efaturagonder(prm1);
            tool.api_post(this, "EFatura/EFatura23rdEntegreGonder", prm1).then(
              response => {
                this.eBillLoadingCount = lastNumber;

                this.itemsefatura = response.body
                this.islemstatus = false;
                if(this.eBillLastNumber >= this.eBillTotalCount){
                    this.getList(1, 50, 'InvoiceDate', true);
                    this.billProgress = false;
        
                    response.body.forEach(element => {
                      this.itemsefatura.push(element); 
                    });
                }else{
                  var checkLastActions = totalCount - lastNumber ;
                  this.eBillFirstNumber = this.eBillLastNumber;
                  if(checkLastActions > 0 && 2 > checkLastActions){

                   response.body.forEach(element => {
                       this.itemsefatura.push(element); 
                   });
                  
                   this.eBillLastNumber = checkLastActions + this.eBillLastNumber;
                   this.sendEbill(this.eBillFirstNumber,this.eBillLastNumber,totalCount,billList);
                
                  }else{
                  response.body.forEach(element => {
                      this.itemsefatura.push(element); 
                  });

                   this.eBillLastNumber = 2 + this.eBillLastNumber;
                   this.sendEbill(this.eBillFirstNumber,this.eBillLastNumber,totalCount,billList);
                   
                  }
            
                }
                
              },
              response => {
                this.islemstatus = false;
                let itemError = {
                  OperationCompleted : false,
                  guid: 0 ,
                  error:response.body.MessageDetail
                }
                this.eBillColor = 'red';
                this.itemsefatura.push(itemError); 
                this.status = tool.responseToStatus(response);
              }
            );

      },
      dialogsonuciptalv2() {
        this.dialogsonucv2 = false;
        this.getList(1, 50, 'InvoiceDate', true)
        //   this.getList(1, this.kayitadet, this.siralamatipi, false)
      },
      OnayaGonderTopluv2() {
        var efaturalist = []
        this.successIntegrates=[];

        if (this.secilenkayitlar.length > 0) {
          this.islemstatus=true;
          this.secilenkayitlar.forEach(element => {

if (element.GenelBilgileri.FaturaTip == 1) {
  let kayit = {
    id: element.GenelBilgileri.EFaturaShowID.EFaturaID,
    guid: element.GenelBilgileri.EFaturaShowID.EFaturaGuid
  }
  efaturalist.push(kayit)

} else if (element.GenelBilgileri.FaturaTip == 2) {

  let kayit = {
    id: element.GenelBilgileri.EFaturaShowID.EFaturaID,
    guid: element.GenelBilgileri.EFaturaShowID.EFaturaGuid
  }
  efaturalist.push(kayit)
}
});


        var prm = {
          faturaTip: this.secilenkayitlar[0].GenelBilgileri.FaturaTip,
          faturaList: efaturalist
        };

        tool.api_post(this, "EFatura/EFatura23rdEntegreGonder", prm).then(
          response => {
            this.loadingdialog = false;
                if (response.body.Status==true)
            {
                this.text1 = response.body.ResponseMessage;
                this.snackbar = true
                this.getList(1, 50, 'InvoiceDate', true)
                this.islemstatus=false;
            }
            else
            {
                this.islemstatus=false;
                this.entegrasyonBasariliSayi=0;
                this.entegrasyonBasarisizSayi=0;
                response.body.Returns.forEach((item)=>{
                    if (item.Error==false)
                {
                   
                    this.entegrasyonBasariliSayi+=1;
                }
                else
                {
                    this.entegrasyonBasarisizSayi+=1;
                }
                var entg = {
                    BiletNo: item.sendFaturaNo,
                    Error:item.Error,
                    ErrorMessage:item.ErrorMessage
                   
                }
                this.successIntegrates.push(entg);
})
this.dialogsonucv2=true;
            }
          },
          response => {
            this.islemstatus = false
            this.status = tool.responseToStatus(response);
          }
        );


        }
        else {
          this.text1 = this.$t('Please-choose-records')
          this.islemstatus = false;
          this.snackbar = true
        }
       
       
      },
      onayaGonderToplu() {
        if (this.secilenkayitlar.length > 0) {
          this.islemstatus = true
          // this.dialogProgress = true;
          this.eBillColor = 'green';
          this.eArchiveColor = 'green';
          this.eArchiveLastNumber = 0;
          this.eBillLastNumber = 0;
          this.itemsefatura = [];
          this.itemsearsiv = [];
          this.dialogsonuc = true;
          this.filtreUyari = false
          var efaturalist = []
          var earsivlist = []

          this.secilenkayitlar.forEach(element => {

            if (element.GenelBilgileri.FaturaTip == 1) {
              let kayit = {
                id: element.GenelBilgileri.EFaturaShowID.EFaturaID,
                guid: element.GenelBilgileri.EFaturaShowID.EFaturaGuid
              }
              efaturalist.push(kayit)

            } else if (element.GenelBilgileri.FaturaTip == 2) {

              let kayit = {
                id: element.GenelBilgileri.EFaturaShowID.EFaturaID,
                guid: element.GenelBilgileri.EFaturaShowID.EFaturaGuid
              }
              earsivlist.push(kayit)
            }
          });

          
          if(efaturalist.length > 0){
              this.billProgress = true;
              this.eBillTotalCount = efaturalist.length;
              this.sendEbill(this.eBillFirstNumber,this.eBillLastNumber,this.eBillTotalCount,efaturalist);
          }

          if(earsivlist.length > 0){
              this.archiveProgress = true;
              this.eArchiveTotalCount = earsivlist.length;
              this.sendEArchive(this.eArchiveFirstNumber,this.eArchiveLastNumber,this.eArchiveTotalCount,earsivlist);
          }



        } else {
          this.text1 = this.$t('Please-choose-records')
          this.islemstatus = false;

          this.snackbar = true
        }


      },
      dialogsonuciptal() {
        this.dialogsonuc = false
        this.filtrefaturatipfaturaView = false
        this.filtretip = '0'
        this.SerbestFatura.EfaturaTip = '0'
        this.SerbestFatura.FaturaStatusTip = 0
        this.billProgress = false;
        this.archiveProgress = false;
        this.eArchiveLastNumber = this.eArchiveTotalCount;
        this.eBillLastNumber = this.eBillTotalCount;
        this.filtreiptal();
        //   this.getList(1, this.kayitadet, this.siralamatipi, false)
      },
      faturaiptaldialog() {

        if (this.secilenkayitlar.length > 0) {


          this.dialogsor = true


        } else {
          this.text1 = this.$t('Please-select-the-invoices-to-be-canceled')
          this.snackbar = true
        }
      },

      faturaserinodialogac() {

        if (this.secilenkayitlar.length == 1) {
         var credentials = JSON.parse(window.localStorage.getItem('credentials'))
        if (credentials.EFatura != '1') {
         this.faturaNoCheck = false; // ana sirket e faturaci degilse kagit fatura.
        }
        this.secilenkayitlar.forEach(element => {
            if(element.GenelBilgileri.Tip != "BLT"){
              this.text1 = this.$t('You-can-change-the-invoice-serial-number-via-the-ticket-invoice.')
              this.snackbar = true
            }else{
              this.faturaserinoDialog = true

            }
        });
        } else {
          this.text1 = this.$t('You-can-change-the-invoice-serial-number-via-the-one-record.')
          this.snackbar = true
        }
      },

      faturaserinodegistir() {

        if (this.$refs.formserino.validate()) {

          var credentials = JSON.parse(window.localStorage.getItem('credentials'));

          var degistirilecekkayitlar = []

          this.secilenkayitlar.forEach(element => {
            var degisKayit = {
              SirketKodu: credentials.SirketKodu,
              FaturaTarihi: element.GenelBilgileri.FaturaTarih,
              FaturaSeri: element.GenelBilgileri.FaturaSeri,
              FaturaNo: element.GenelBilgileri.Faturano,
              YeniFaturaSeri: this.Faturaseri,
              YeniFaturaNo: this.Faturano,
              CoperSirketNo: credentials.CoperSirketNo,
              FaturaTip: element.GenelBilgileri.Tip,
              FaturaUnique:element.GenelBilgileri.FaturaUnique

            }

            degistirilecekkayitlar.push(degisKayit);

          });

          var params = degistirilecekkayitlar[0];


          this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceChange', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

            this.text1 = response.body.FaturaResponse
            this.snackbar = true

            if (response.body.FaturaStatus === true) {

              this.faturaserinoDialog = false
              this.getList(1, 50, 'InvoiceDate', true)

            } 

          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable-InvoiceChange'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable-InvoiceChange'
              this.snackbar = true
            }
          })

        } else {
          this.text1 = this.$t('Invoice-Serial-Number-cannot-be-left-blank.')
          this.snackbar = true
        }
      },

      faturaiptalet() {
        this.islemstatus = true;
        var iptaledilecekkayitlar = []

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.secilenkayitlar.forEach(element => {
          var kayit = {
            SirketKodu: credentials.SirketKodu,
            FaturaTarihi: element.GenelBilgileri.FaturaTarih,
            FaturaSeri: element.GenelBilgileri.FaturaSeri,
            CariKodu: element.GenelBilgileri.Cari.Kod,
            FaturaNo: element.GenelBilgileri.Faturano,
            FaturaTip: element.GenelBilgileri.Tip,
            EFaturaId: element.GenelBilgileri.EFaturaShowID.EFaturaID,
            FaturaUnique:element.GenelBilgileri.FaturaUnique

          }
          iptaledilecekkayitlar.push(kayit)
        });



        var params = iptaledilecekkayitlar

        this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceCancel', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
            this.islemstatus = false;

          if (response.body[0].FaturaStatus == true) {
            this.dialogsor = false
            this.text1 = this.$t('Your-invoice-cancellation-process-is-completed.')
            this.snackbar = true
            this.getList(1, 50, 'InvoiceDate', true)
          } else {
            this.dialogsor = false
            this.text1 = response.body[0].FaturaResponse;
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.islemstatus = false;
            this.text1 = 'Service Unavailable-InvoiceCancel'
            this.snackbar = true
            this.dialogsor = false
          } else {
            let data ={
            response: response,
            request: params,
            api:'TicketInvoice/InvoiceCancel',
            type:2,
            message: response.body.ExceptionMessage
            };
            this.$refs.showMessage.open(data);
            this.islemstatus = false;
            this.dialogsor = false
          }
        })
      },
      getList: getList,

      getListHtml: getListHtml,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
      git: git,
      kayitcek: kayitcek,
      efaturagoster: efaturagoster,
      tarihkontrol: tarihkontrol,
      reportbrobas: reportbrobas,
      gitcopy: gitcopy,
      gitpdflink:gitpdflink,
      gitInvoiceStatus:gitInvoiceStatus
    },
  }
  function gitInvoiceStatus(kayit)
 {
  this.InvoiceSatatusFat=kayit.Faturano;
  this.InvoiceSatatusDesc=kayit.InvoiceStatus;
  this.dialoginvoicestatus=true;
 }
 function gitpdflink(kayit)
 {
  var url =kayit.PdfLink;
      window.open(url, '_target')
 }
  function gitcopy(kayit)
  {
    if (kayit.Tip == "SER") {
      var evraktip = "SF"
      var url = '#/fatura/faturakopya/id?' + 'ft=' + kayit.FaturaTarih + '&ck=' + kayit.Cari.Kod + '&et=' +
        evraktip +
        '&es=' +
        kayit.FaturaSeri + '&en=' + kayit.Faturano + '&ner=' + "X" + '&sb=' + true + '&islem=get'
      window.open(url, '_target')
    } else {
      this.text1 = this.$t('Please-Choose-a-Free-Invoice')
      this.snackbar = true
    }
  }
  function git(kayit) {
    if (kayit.Tip == "SER") {
      var evraktip = "SF"
      var url = '#/fatura/serbestfatura/id?' + 'ft=' + kayit.FaturaTarih + '&ck=' + kayit.Cari.Kod + '&et=' +
        evraktip +
        '&es=' +
        kayit.FaturaSeri + '&en=' + kayit.Faturano + '&ner=' + "X" + '&sb=' + true + '&islem=get'
      window.open(url, '_target')
    } else {
      this.text1 = this.$t('Please-Select-Free-Invoice')
      this.snackbar = true
    }
  }

  function efaturagoster(v, y) {

    var params = {
      id: y,
      guid: v
    }

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    this.$http.post(auth.API_URL + 'api/EFatura/FaturaShow', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader(),
        'CariSirketNo': String(credentials.SirketKodu),
        'CoperSirketNo': String(credentials.CoperSirketNo),
      }
    }).then((response) => {
      this.faturadialog = true
      document.getElementById("demo2").innerHTML = response.body;
      // document.getElementById('demo2').contentWindow.document.body.innerHTML = response.body;
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-FaturaShow'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-FaturaShow'
        this.snackbar = true
      }
    })
  }

  function reportbrobas(v, y, dizaynkod) {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    this.dizayn = dizaynkod;

    var prm1 = {
      id: y,
      guid: v
    };

    var prm = {
      SablonId: this.dizayn,
      PrintObjectName: null,
      IsTestData: false,
      Prm: prm1
    };

    this.$http.post(auth.API_URL + 'api/ReportBro/ReportBroPrintPdf2', prm, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader(),
        'CariSirketNo': String(credentials.SirketKodu),
        'CoperSirketNo': String(credentials.CoperSirketNo)
      },
      responseType: "application/json"
    }).then((response) => {

      if (response.body.Status == true) {

        this.dialogOnizleme = true;

        var dosya = helpers.base64ToArrayBuffer(response.body.data);
        var blob = new Blob([dosya], {
          type: "application/pdf"
        });
        var file1 = window.URL.createObjectURL(blob);
        document.getElementById("denemem").src = file1;
      } else {
        this.text1 = response.body.ErrorList[0];
        this.snackbar = true
        this.dialogOnizleme = false;
      }

    }, (response) => {

      this.text1 = response.body.ErrorList[0];
      this.snackbar = true
      this.dialogOnizleme = false;

    })




  }

  function tarihkontrol(v) {

    if (v != "0001-01-01T00:00:00") {
      var parts = v.split("T");
      var parts1 = parts[0].split("-");
      return (parts1[2] + '-' + parts1[1] + '-' + parts1[0]);
    } else {
      return null;
    }
  }


  function getList(sayfanoo, kayitadett, siralatipp, aramayapildimi, aranankelime) {

    this.aramayapildi = aramayapildimi
    if (this.$refs.formtarih.validate()) {

      var bastarih = new Date(this.date)
      var bittarih = new Date(this.date2)

      if (bastarih <= bittarih) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.progress = true
        this.load1 = false
        this.secilenkayitlar = []
        this.tumunuseckaldir = false

        if (this.tumsirketler === true) {
          this.SerbestFatura.SirketKodu = '0'
        } else {
          this.SerbestFatura.SirketKodu = credentials.SirketKodu
        }

        if (aramayapildimi == true) {
          this.SerbestFatura.TextSearch = aranankelime
          this.SerbestFatura.BaslangicTarih = this.date
          this.SerbestFatura.BitisTarih = this.date2
          this.SerbestFatura.Paging.VeriAdet = 50
          this.SerbestFatura.Paging.SiralamaTip = 'InvoiceDate'
          this.SerbestFatura.Paging.SayfaNo = 1
          this.yedekfaturaclass = this.SerbestFatura;
        } else {
          this.SerbestFatura = this.yedekfaturaclass;
          this.SerbestFatura.TextSearch = null
          this.searchliste = null
          this.SerbestFatura.Paging.VeriAdet = kayitadett
          this.SerbestFatura.Paging.SiralamaTip = siralatipp;
          this.SerbestFatura.Paging.SayfaNo = sayfanoo;
        }

        var params = this.SerbestFatura
        this.yedekListInput = this.SerbestFatura;

        this.$http.post(auth.API_URL + 'api/Report/Invoice3rdIntegrateReport', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          this.islemstatus = false

          if (response.body.FaturaBilgi.length > 0) {
            this.kayitvarmi = true;
            this.pagenumber = response.body.TotalPage;
            this.vmodelpagination = true;
            this.recordcount = this.$t('Total') + response.body.TotalCount + this.$t('number-records-listed');
            this.items = response.body.FaturaBilgi
            this.serbestAdet = response.body.FaturaToplamlar.SerbestFaturaAdet;
            this.coperAdet = response.body.FaturaToplamlar.CoperFaturaAdet;
            this.biletAdet = response.body.FaturaToplamlar.BiletFaturaAdet;
            this.ToplamAdetbilcopser = response.body.FaturaToplamlar.ToplamFaturaAdet;
            this.kagıtAdet = response.body.FaturaToplamlar.FaturaAdet;
            this.efaturaAdet = response.body.FaturaToplamlar.EFaturaAdet;
            this.earsivAdet = response.body.FaturaToplamlar.EArsivAdet;
            this.ToplamAdetkagefatears = response.body.FaturaToplamlar.ToplamFaturaAdet;
            this.toplamKDV = response.body.FaturaToplamlar.ToplamKdv
            this.ToplamMatrah = 0;
            this.ToplamKDVMat = response.body.FaturaToplamlar.ToplamTutar

            var editdizi = []

            this.items.forEach(element => {

              var yenikayit = [];

              yenikayit.GenelBilgileri = element;

              var tutarlar = {
                Tutar: element.Tutar,
                KalanTutar: element.Kalan,
                Kdv: element.Kdv
              }

              yenikayit.tutarlar = tutarlar;

              var tarih = {
                FaturaTarihi: tarihkontrol(element.FaturaTarih),
              }

              yenikayit.TarihBilgileri = tarih;

              editdizi.push(yenikayit)
            });

            this.items = editdizi;
            this.progress = false
            this.load1 = true
            this.vmodelpagination = true;

          } else {
            this.aramayapildi = false;
            this.kayitvarmi = false;
            this.load1 = true
            this.items = [];
            this.vmodelpagination = false;
            this.recordcount = ""
            this.text1 = this.$t('No-Records-Found')
            this.snackbar = true
          }

        }, (response) => {
          this.islemstatus = false
          if (response.status === 0) {

            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.aramayapildi = false;

            this.load1 = true

          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.aramayapildi = false;

            this.load1 = true

          }
        })

      } else {
        this.islemstatus = false
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }

  function kayitcek(v) {

    var params = {
      id: v.EFaturaShowID.EFaturaID,
      guid: v.EFaturaShowID.EFaturaGuid
    }

    this.$http.post(auth.API_URL + 'api/EFatura/GetFatura', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.faturadialog = true
      document.getElementById("demo2").innerHTML = response.body;
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      }
    })
  }

  function getListHtml() {

    if (this.$refs.formtarih.validate()) {

      var bastarih = new Date(this.date)
      var bittarih = new Date(this.date2)

      if (bastarih <= bittarih) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var lang = localStorage.getItem('lang')
        this.progress = true
        this.load1 = false
        this.secilenkayitlar = []
        this.tumunuseckaldir = false

        if (this.tumsirketler === true) {
          this.SerbestFatura.SirketKodu = '0'
        } else {
          this.SerbestFatura.SirketKodu = credentials.SirketKodu
        }

        this.SerbestFatura = this.yedekfaturaclass;
        this.SerbestFatura.TextSearch = null
        this.searchliste = null
        this.SerbestFatura.Paging.VeriAdet = this.kayitadet
        this.SerbestFatura.Paging.SiralamaTip = this.siralamatipi;
        this.SerbestFatura.Paging.SayfaNo = null;



        var params = this.SerbestFatura
        this.yedekListInput = this.SerbestFatura;


        this.$http.post(auth.API_URL + 'api/Report/InvoiceReportHtml', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {


          this.progress = false
          this.load1 = true
          if (lang=='en')
          {
            
              var bodyhtml=helpers.getTranslatedHtml(response.bodyText) ;
             
              bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>FATURA LİSTESİ</font>"," <font face = 'Arial' size = '4' color = '#FFFFF0'>Invoices List</font>");
              bodyhtml=bodyhtml.toString().replace('FATURA LİSTESİ','Invoices List');
              bodyhtml=bodyhtml.toString().replace('Fatura Tarihi','Invoice Date');
              bodyhtml=bodyhtml.toString().replace("<font face = 'Tahoma' size = '1' color = '#FFFFF0'>Fatura Seri</font>","<font face = 'Tahoma' size = '1' color = '#FFFFF0'>Invoice Serial</font>");
              bodyhtml=bodyhtml.toString().replace('Fatura No','Invoice No');
              bodyhtml=bodyhtml.toString().replace("<font face = 'Tahoma' size = '1' color = '#FFFFF0'>Fatura No</font>","<font face = 'Tahoma' size = '1' color = '#FFFFF0'>Invoice No</font>");
              bodyhtml=bodyhtml.toString().replace('Unvani','Title');
              bodyhtml=bodyhtml.toString().replace('Tutar','Total');
              bodyhtml=bodyhtml.toString().replace('Aralığı ','Between');
              bodyhtml=bodyhtml.toString().replace('Invoice No Aralığı ','Invoice Number Range');
              bodyhtml=bodyhtml.toString().replace('Fatura Türü ','Invoice Type');
              bodyhtml=bodyhtml.toString().replace('Vergi Dairesi','Tax Administration');
              bodyhtml=bodyhtml.toString().replace('Vergi No','Tax Number'); 
              bodyhtml=bodyhtml.toString().replace('TC Kimlik No','ID Number');
              bodyhtml=bodyhtml.toString().replace('Tip','Type');
              bodyhtml=bodyhtml.toString().replace('Fatura Durumu','Invoice Status');
              bodyhtml=bodyhtml.toString().replace(" adet kayıt listelendi.</b>"," Record Listed.</b>");
              
              response.bodyText=bodyhtml;
             
          }

          var blob = new Blob([response.bodyText], {
            type: 'application/html'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download =this.$t('InvoiceReport') + ".html" ;
          link.click();

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true

          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }

  function getListExcel() {

    if (this.$refs.formtarih.validate()) {

      var bastarih = new Date(this.date)
      var bittarih = new Date(this.date2)

      if (bastarih <= bittarih) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.progress = true
        this.load1 = false
        this.secilenkayitlar = []
        this.tumunuseckaldir = false

        if (this.tumsirketler === true) {
          this.SerbestFatura.SirketKodu = '0'
        } else {
          this.SerbestFatura.SirketKodu = credentials.SirketKodu
        }

        this.SerbestFatura = this.yedekfaturaclass;
        this.SerbestFatura.TextSearch = null
        this.searchliste = null
        this.SerbestFatura.Paging.VeriAdet = this.kayitadet
        this.SerbestFatura.Paging.SiralamaTip = this.siralamatipi;
        this.SerbestFatura.Paging.SayfaNo = null;



        var params = this.SerbestFatura
        this.yedekListInput = this.SerbestFatura;


        this.$http.post(auth.API_URL + 'api/Report/InvoiceReportExcel', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          },
          responseType: "arraybuffer"
        }).then((response) => {
          this.progress = false
          this.load1 = true
          var blob = new Blob([response.data], {
            type: 'application/xlsx'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = this.$t('InvoiceReport') + ".xlsx" ;
          link.click();

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }

  function beforeMount() {



  }

  function filtrele() {
    this.dialogfiltre = true
  }

  function filtrekayit() {
    this.filtrevarmi = true

    if (this.filtretip == '1') {
      if (this.filtrefaturatipfatura == true && this.filtrefaturastatus == 1) {
        this.getList(1, this.kayitadet, this.siralamatipi, true)
        this.dialogfiltre = false

      } else {
        this.text1 = this.$t('Please-complete-the-filters')
        this.snackbar = true
      }
    } else if (this.filtretip == '0') {
      this.getList(1, this.kayitadet, this.siralamatipi, false)
      this.dialogfiltre = false
    }
  }

  function filtreiptal() {
    this.filtrevarmi = false
    this.filtretip = '0'
    this.filtreUyari = false
    this.filtrefaturatipfaturaView = false
    this.SerbestFatura.BaslangicFaturaNo = null
    this.SerbestFatura.BitisFaturaNo = null
    this.SerbestFatura.Cari.Kod = null
    this.SerbestFatura.EfaturaTip = '2'
    this.SerbestFatura.FaturaStatusTip = 0
    this.SerbestFatura.MinTutar = 0
    this.SerbestFatura.MaxTutar = 0
    this.SerbestFatura.FaturaTp = 'H'
    this.SerbestFatura.VadeTarihi = false
    this.SerbestFatura.Bakiyeli = false
    this.SerbestFatura.CariyeKaydedilmeyen = false
    this.tumsirketler = false
    this.getList(1, this.kayitadet, this.siralamatipi, false)
    this.renk1 = 'info'
    this.dialogfiltre = false

  }
  
</script>

<style>
  .ScrollStyle1 {
    max-height: 800px;
    max-width: 100%;
    overflow-x:scroll;
    overflow-y: scroll;
  }
</style>